import { render, staticRenderFns } from "./TransferReceipt.vue?vue&type=template&id=b65339fc&scoped=true&"
import script from "./TransferReceipt.vue?vue&type=script&lang=js&"
export * from "./TransferReceipt.vue?vue&type=script&lang=js&"
import style0 from "./TransferReceipt.vue?vue&type=style&index=0&id=b65339fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65339fc",
  null
  
)

export default component.exports